import { Stack } from "@chakra-ui/react";
import { captureEvent } from "@sentry/react";
import { useStore as useAppStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React from "react";
import { useStore } from "../Store";
import { BillingApproaching } from "./BillingApproaching";
import { CreateBillingPlan } from "./CreateBillingPlan";
import { NotInternallyApproved } from "./NotInternallyApproved";
import { UpdateBillingPlan } from "./UpdateBillingPlan";

const Banners = () => {
  const { workspaceStore, UIStore } = useAppStore();
  const store = useStore();
  const router = useRouter();

  const render = {
    internally_approved: !store.project?.hasBudgetsInternallyApproved,
    billing_plan: workspaceStore.settings?.moduleSettings.billing_plan,
    billing_plan_missing: store.project?.billingPlanIsMissing,
    budget_changed:
      store.project?.billingPlanNotifications?.project_budget_changed,
    dates_changed:
      store.project?.billingPlanNotifications?.project_dates_changed,
    invoice_date_approaching:
      store.project?.currentMonthBillingPlanStats
        .show_invoice_date_approaching_warning,
  };
  const marginBottom = Object.entries(render)
    .filter(([key]) => key !== "billing_plan")
    .some(([_, val]) => val === true)
    ? "6"
    : undefined;

  const onCreateBillingPlan = () => {
    if (!store.project) {
      UIStore.toast({ status: "error" });
      captureEvent({
        message: "FE: Missing project to create billing plan",
      });
      return;
    }
    router.push({
      pathname: "/projects/invoicing-plan",
      query: {
        id: store.project.id,
      },
    });
  };

  return (
    <Stack mb={marginBottom} spacing="5">
      {render.internally_approved && (
        <NotInternallyApproved projectId={store.project!.id} />
      )}
      {render.billing_plan && (
        <React.Fragment>
          {(render.billing_plan_missing && (
            <CreateBillingPlan
              projectId={store.project!.id}
              onCreate={onCreateBillingPlan}
            />
          )) ||
            (render.budget_changed && (
              <UpdateBillingPlan
                type="budget"
                projectId={store.project!.id}
                onUpdate={() => store.billingPlanModal.open()}
                onDismiss={(data) =>
                  store.project?.setBillingPlanNotifications(data)
                }
              />
            )) ||
            (render.dates_changed && (
              <UpdateBillingPlan
                type="date"
                projectId={store.project!.id}
                onUpdate={() => store.billingPlanModal.open()}
                onDismiss={(data) =>
                  store.project?.setBillingPlanNotifications(data)
                }
              />
            ))}
          {render.invoice_date_approaching && (
            <BillingApproaching projectId={store.project!.id} />
          )}
        </React.Fragment>
      )}
    </Stack>
  );
};

export default observer(Banners);
